import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import HomepageV1 from "./pages/HomepageV1";
import HomepageV2 from "./pages/HomepageV2";
import HomepageVanishingAct from "./pages/HomepageVanishingAct";
import HomepageUnforgettable from "./pages/HomepageUnforgettable";
import Homepage3SecondAdvantage from "./pages/Homepage3SecondAdvantage";
import HomepageNewFreeQCard from "./pages/HomepageNewFreeQCard";
import HomepageFreeQCardV2 from "./pages/HomepageFreeQCardV2";
import HomepageFreeVersion1 from "./pages/HomepageFreeVersion1";
import HomepageFreeVersion2 from "./pages/HomepageFreeVersion2";
import HomepageEnterprise from "./pages/HomepageEnterprise";
import EnterprisePlan from "./pages/EnterprisePlan";
import NFCBusinessCard from "./pages/NFCBusinessCard";
import ConsultingDigitalBusinessCard from "./pages/ConsultingDigitalBusinessCard";
import InsuranceDigitalBusinessCard from "./pages/InsuranceDigitalBusinessCard";
import RealEstateDigitalBusinessCard from "./pages/RealEstateDigitalBusinessCard";
import AccountingDigitalBusinessCard from "./pages/AccountingDigitalBusinessCard";
import FinancialAdvisoryDigitalBusinessCard from "./pages/FinancialAdvisoryDigitalBusinessCard";
import LawDigitalBusinessCard from "./pages/LawDigitalBusinessCard";
import SignupConfirmation from "./pages/SignupConfirmation";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const shouldUseHashRouter =
  typeof window !== "undefined" && window.location.hash.startsWith("#/");

const Router = shouldUseHashRouter ? HashRouter : BrowserRouter;

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <Router>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/homepage-v1" element={<HomepageV1 />} />
          <Route path="/homepage-v2" element={<HomepageV2 />} />
          <Route path="/homepage-vanishing-act" element={<HomepageVanishingAct />} />
          <Route path="/homepage-unforgettable" element={<HomepageUnforgettable />} />
          <Route path="/homepage-3-second-advantage" element={<Homepage3SecondAdvantage />} />
          <Route path="/homepage-new-free-qcard" element={<HomepageNewFreeQCard />} />
          <Route path="/homepage-free-qcardv2" element={<HomepageFreeQCardV2 />} />
          <Route path="/homepage-free-version1" element={<HomepageFreeVersion1 />} />
          <Route path="/homepage-free-version2" element={<HomepageFreeVersion2 />} />
          <Route path="/homepage-enterprise" element={<HomepageEnterprise />} />
          <Route path="/enterprise-plan" element={<EnterprisePlan />} />
          <Route path="/nfc-business-card" element={<NFCBusinessCard />} />
          <Route path="/consulting-digital-business-card" element={<ConsultingDigitalBusinessCard />} />
          <Route path="/insurance-digital-business-card" element={<InsuranceDigitalBusinessCard />} />
          <Route path="/real-estate-digital-business-card" element={<RealEstateDigitalBusinessCard />} />
          <Route path="/accounting-digital-business-card" element={<AccountingDigitalBusinessCard />} />
          <Route path="/financial-advisory-digital-business-card" element={<FinancialAdvisoryDigitalBusinessCard />} />
          <Route path="/law-digital-business-card" element={<LawDigitalBusinessCard />} />
          <Route path="/signup-confirmation" element={<SignupConfirmation />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
